<template>
    <div class="layout-container table-special">
        <div v-if="type == 2" class="search-condition-con" :class="'show'">
            <div class="search-condition">
                <span class="label">条件类型</span>
                <div class="input-condition">
                    <el-radio-group v-model="condition.condition_page_type" size="medium" @change="conChange">
                        <el-radio-button label="1">固定条件</el-radio-button>
                        <el-radio-button label="2">组合条件</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
        </div>
        <!-- <div class="btn-condition" v-if="condition.condition_page_type == '2'">
            <el-button type="primary" @click="handleAdd()" v-permission="'business.page-tdk.combination-create'">新增组合条件</el-button>
        </div> -->
        <el-table :data="list" border style="width: 100%" v-loading="isLoading">
            <el-table-column prop="page_name" label="页面名称"></el-table-column>
            <el-table-column prop="title" label="标题"></el-table-column>
            <el-table-column prop="description" label="描述"></el-table-column>
            <el-table-column prop="keywords" label="关键词"></el-table-column>
            <el-table-column prop="operator" label="编辑人"></el-table-column>
            <el-table-column prop="updated_at" label="编辑时间"></el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button  type="text" size="mini" @click="openEdit(scope.row)" v-permission="'business.page-tdk.combination-edit'"
                        >编辑</el-button>
                    <!-- <el-button type="text" v-if="condition.condition_page_type == '2'" v-permission="'business.page-tdk.combination-edit'" size="mini" @click="handleDelete(scope.row.id)"
                        >删除</el-button>     -->
                </template>
            </el-table-column>
        </el-table>
        <edit ref="edit" :callback="initData" @showTagLib="showTagLib"/>
        <group-edit ref="groupEdit" :callback="initData" @showTagLib="showTagLib"/>
        <tag-lib ref="tagLib"></tag-lib>
    </div>
</template>
<script>
import edit from './edit'
import groupEdit from './groupEdit'
import TagLib from './tagLib';
import {getPageTdkslist,deletePageTdks} from '@/service/tdkManage'
export default {
    name:"pageList",
    components:{
        edit,
        groupEdit,
        TagLib
    },
    props:{
        type:{
            type:String,
            default:"1"
        }
    },
    data() {
        return {
            list:[],
            isLoading:false,
            conditionType:"1",
            condition:{
                page_type:"",
                condition_page_type:"1"
            },
            host:""
        }
    },
    mounted(){
        const domain=document.domain
        this.host = window.serverConfig[window.siteMap[domain]].HOST
        this.initData();
    },
    methods:{
        openEdit(row){
            // if(this.condition.condition_page_type == '2'){
            //     this.$refs.groupEdit && this.$refs.groupEdit.open(row)
            // }else{
            //     this.$refs.edit && this.$refs.edit.open(row)
            // }
            this.$refs.edit && this.$refs.edit.open(row)

        },
        handleAdd(){
            this.$refs.groupEdit && this.$refs.groupEdit.open()
        },
        initData(){
            this.isLoading = true;
            this.condition.page_type = this.type
            getPageTdkslist(this.condition).then(res => {
                // this.list = res
                if(this.host.indexOf("loushi") == -1){

                    this.list = res.map(item => {
                        if(item.page_name != "房产百科" || item.page_name != "地图找房"){
                            return item
                        }
                    })
                }else{
                    this.list = res
                }
                this.isLoading = false;
            }).catch(err =>{
                this.isLoading = false;
            })
            
        },
        conChange(){
            this.initData()
        },
        showTagLib(){
            this.$refs.tagLib.openMenu()
        },
        // handleDelete(id) {
        //     this.$confirm("请确认是否删除该内容项？", "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning"
        //     }).then(() => {
        //         deletePageTdks(id)
        //         .then(() => {
        //             this.$message({
        //             type: "success",
        //             message: "删除成功"
        //             });
        //             this.initData();
        //         })
        //         .catch(err => {
        //             this.$message({
        //             type: "error",
        //             message: err.message || "删除失败"
        //             });
        //         });
        //     });
        // },
    }
}
</script>
<style scoped>

</style>